import { Merchant } from '@givebacks/api/offers';
import {
  MerchantDetailModal,
  MerchantDetailModalProvider,
  MerchantOfferTermsModal,
  useMerchantDetailModalProvider,
} from 'core/Components';
import { Divider, OnlineMerchantCard, Stack } from 'ui';

import { useAffiliateLink } from '../../useAffiliateLink/useAffiliateLink';

type MerchantCardProps = {
  merchant: Merchant;
  withDivider?: boolean;
};

const MerchantCard = ({ merchant, withDivider = true }: MerchantCardProps) => {
  const { navigate: handleVisit } = useAffiliateLink(merchant);

  const { openModalById } = useMerchantDetailModalProvider({});

  return (
    <Stack gap={0}>
      <OnlineMerchantCard
        onTitleClick={() => openModalById('Detail')}
        name={merchant.name}
        tagline={merchant.tagline}
        logoSrc={merchant.logo?.url}
        domain={merchant.domain}
        buttonProps={{
          onClick: handleVisit,
        }}
      />
      {withDivider && <Divider />}
    </Stack>
  );
};

const MerchantCardWrapper = ({ merchant }: { merchant: Merchant }) => {
  const { navigate: handleVisit } = useAffiliateLink(merchant);

  return (
    <MerchantDetailModalProvider
      meta={{
        merchantId: merchant.uuid,
        type: 'online',
        onCtaClick: handleVisit,
      }}
    >
      <MerchantCard merchant={merchant} />
      <MerchantDetailModal handleClick={handleVisit} />
      <MerchantOfferTermsModal />
    </MerchantDetailModalProvider>
  );
};

export { MerchantCardWrapper };
